// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__13chZ","content":"Page_content__tyQ8t","scrollingDisabled":"Page_scrollingDisabled__2bQpF"};